import React, { useState, useEffect } from 'react';

export default function DemoCTA() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <section
      style={{
        background: 'var(--bg2)',
        padding: isMobile ? '3rem 1rem' : '5rem 2rem',
        textAlign: 'center',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Grid background */}
      <div
        style={{
          position: 'absolute',
          inset: 0,
          backgroundImage:
            'linear-gradient(rgba(15,244,198,0.025) 1px, transparent 1px), linear-gradient(90deg, rgba(15,244,198,0.025) 1px, transparent 1px)',
          backgroundSize: isMobile ? '30px 30px' : '50px 50px', // ✅ responsive grid
          pointerEvents: 'none',
        }}
      />

      {/* Glow effect */}
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%,-50%)',
          width: isMobile ? '280px' : '500px', // ✅ responsive
          height: isMobile ? '280px' : '500px',
          borderRadius: '50%',
          background:
            'radial-gradient(circle, rgba(15,244,198,0.06) 0%, transparent 70%)',
          pointerEvents: 'none',
        }}
      />

      <div
        style={{
          maxWidth: '640px',
          margin: '0 auto',
          position: 'relative',
          zIndex: 1,
        }}
      >
        {/* Badge */}
        <div
          style={{
            display: 'inline-block',
            background: 'rgba(251,191,36,0.12)',
            border: '1px solid rgba(251,191,36,0.3)',
            color: '#fbbf24',
            fontSize: '12px',
            fontWeight: '700',
            letterSpacing: '0.08em',
            padding: '6px 14px',
            borderRadius: '999px',
            marginBottom: '1.2rem',
            textTransform: 'uppercase',
          }}
        >
          30% off on enrollment
        </div>

        {/* Heading */}
        <h2
          style={{
            fontSize: 'clamp(26px, 6vw, 54px)',
            fontWeight: '800',
            color: '#f0f4ff',
            lineHeight: 1.2,
            marginBottom: '1rem',
          }}
        >
          Start with a <span style={{ color: '#0ff4c6' }}>free</span>
          <br />
          demo class
        </h2>

        {/* Description */}
        <p
          style={{
            fontSize: isMobile ? '14px' : '15px',
            color: '#94a3c4',
            lineHeight: 1.7,
            marginBottom: '2rem',
            padding: isMobile ? '0 10px' : '0',
          }}
        >
          Try any course — no payment required. Unlock 30% off the full course
          price when you enroll after your free demo session.
        </p>

        {/* Buttons */}
        <div
          style={{
            display: 'flex',
            gap: '12px',
            justifyContent: 'center',
            flexDirection: isMobile ? 'column' : 'row', // ✅ stack on mobile
            alignItems: 'center',
          }}
        >
          <button
            style={{
              width: isMobile ? '100%' : 'auto',
              background: '#0ff4c6',
              color: '#080b14',
              border: 'none',
              padding: '14px 24px',
              borderRadius: '999px',
              fontSize: '14px',
              fontWeight: '600',
              cursor: 'pointer',
            }}
          >
            Book your free demo →
          </button>

          <button
            style={{
              width: isMobile ? '100%' : 'auto',
              background: 'transparent',
              color: '#f0f4ff',
              border: '1.5px solid rgba(99,179,237,0.25)',
              padding: '14px 24px',
              borderRadius: '999px',
              fontSize: '14px',
              cursor: 'pointer',
            }}
          >
            Call us to know more
          </button>
        </div>
      </div>
    </section>
  );
}